<template>
    <div v-html="legendHtml"></div>
</template>

<script>
    export default {
        name: 'PrintLegend',
        data() {
            return { legendHtml: null };
        },
        created() {
            this.$_getLegendHtml();
        },
        methods: {
            $_getLegendHtml() {
                this.legendHtml = null;
                const legendElement = document.querySelector('.legends');
                // if the legend contains divs, there is content to show
                if (legendElement) {
                    const hasDivs = legendElement.querySelectorAll('div');
                    if ([...hasDivs].length > 0) {
                        this.legendHtml = legendElement.innerHTML;

                        // Remove this class to hide checkboxes
                        this.legendHtml = this.legendHtml.replaceAll(
                            'class="custom-control-label"'
                        );
                    }
                }
            }
        }
    };
</script>

<style>
.print-overlay.legend table {
    margin-bottom: 10px;
}

.print-overlay.legend .no-print,
.print-overlay.legend .legend-col-checkbox {
    display: none;
}

.print-overlay.legend .custom-control {
    padding-left: 0.5rem;
}

.print-overlay.legend .card-body {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}
</style>
